/** https://developers.google.com/youtube/iframe_api_reference */

declare global {
    interface Window { onYouTubeIframeAPIReady: Function; }
}

import { Vue } from 'vue-property-decorator';
export const YoutubeServiceEvents = new Vue();

class YoutubeServiceClass {
    public loaded = false;
    public apiReady = false;

    public load(): void {
        if (!this.loaded) {
            this.loaded = true;

            window.onYouTubeIframeAPIReady = () => {
                this.apiIsReady();
            };
            
            this.createApiScript();
        }              
    }

    private createApiScript(): void {
        let scriptTag = document.createElement('script');
        scriptTag.src = "//www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        if (firstScriptTag && firstScriptTag.parentNode) {
            firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        }
    }

    private apiIsReady(): void {
        YoutubeServiceEvents.$emit('apiReady', true);
        this.apiReady = true;
    }
}

export let YoutubeService = new YoutubeServiceClass();